import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    agentDetails: [],
    supplierDetails: [],
  },
  getters: {
    agentDetails: (state) => state.agentDetails,
    supplierDetails: (state) => state.supplierDetails,
  },
  actions: {
    fetchPartiesSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("BusinessParties/api/PartiesQuery/" + name)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    membersFromAgent({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "BusinessParties/api/AgentMembersQuery/" + id + "?Take=100&Skip=0"
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    channelPartiesSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "BusinessParties/api/PartiesQuery/" +
              name +
              "?customerAgentTypeQuery=2"
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    channelAgentsSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "BusinessParties/api/AgentsInfoQuery/" +
              name +
              "/AllAgentInfoDictionary"
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    channelCurrentUserAgentsSearch({ commit, dispatch }, agentName) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Sales/api/SalePersonQuery/CurrentUser/" +
              agentName +
              "/AgentInfoDictionary"
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    fetchSingleAgent({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("BusinessParties/api/AgentsInfoQuery/" + id)
          .then((r) => {
            commit("setAgentDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchSingleSupplier({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("BusinessParties/api/SuppliersInfoQuery/" + id)
          .then((r) => {
            commit("setSupplierDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchSingleSupplier({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("BusinessParties/api/SuppliersInfoQuery/" + id)
          .then((r) => {
            commit("setSupplierDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    searchAgent({ commit }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("BusinessParties/api/AgentsInfoQuery/by-name/" + name)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    searchSalePerson({ commit }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/SalePersonQuery/by-owner/" + name)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    assignUserToAgents({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/AgentMembers", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    removeUserToAgents({ commit, dispatch }, model) {
      return ajax
        .delete(
          "BusinessParties/api/AgentMembers",
          { data: model },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then(() => {});
    },
  },
  mutations: {
    setAgentDetails(state, data) {
      state.agentDetails = data;
    },
    setSupplierDetails(state, data) {
      state.supplierDetails = data;
    },
  },
};
